import type { AppState } from '../domain/types'

const DATABASE = 'strata-local'
const STORE = 'state'
const LEGACY_KEY = 'current'

function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1)
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE)) request.result.createObjectStore(STORE)
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

export async function loadState(accountId: string): Promise<AppState | undefined> {
  const database = await openDatabase()
  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE, 'readwrite')
    const store = transaction.objectStore(STORE)
    const key = accountKey(accountId)
    const request = store.get(key)
    request.onsuccess = () => {
      if (request.result) {
        resolve(request.result as AppState)
        return
      }
      const legacy = store.get(LEGACY_KEY)
      legacy.onsuccess = () => {
        if (legacy.result) {
          store.put(legacy.result, key)
          store.delete(LEGACY_KEY)
        }
        resolve(legacy.result as AppState | undefined)
      }
      legacy.onerror = () => reject(legacy.error)
    }
    request.onerror = () => reject(request.error)
  })
}

export async function saveState(accountId: string, state: AppState): Promise<void> {
  const database = await openDatabase()
  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE, 'readwrite')
    transaction.objectStore(STORE).put(state, accountKey(accountId))
    transaction.oncomplete = () => resolve()
    transaction.onerror = () => reject(transaction.error)
  })
}

const accountKey = (accountId: string) => `account:${accountId.trim().toLocaleLowerCase('en-US')}`
